import Api from "../api/SystemSettings";
import { StatusInfo, WithBooleanFlag } from "./core";
import Constants from "../constants/Common";
import { makeAutoObservable, runInAction } from "mobx";

export class SystemSettingsStore {
  isLoading = new WithBooleanFlag(false);
  gatiOrderSettings = {};
  grpSettings = {};
  asuEdsSettings = {};
  ppurSettings = {};
  messageStatus = new StatusInfo();
  sitPanelConfig = null;

  constructor() {
    makeAutoObservable(this);
  }

  loadGatiOrderSettings = async () => {
    const res = await Api.getGatiOrderSettings();
    return runInAction(() => {
      this.gatiOrderSettings = res.data;
    });
  };

  saveGatiOrderSettings = async (data) => {
    this.isLoading.setTrue();
    try {
      await Api.updateGatiOrderSettings(data);
      this.messageStatus.setStatus(Constants.statusMessage.updated);
    } catch (ex) {
      this.messageStatus.setDetails(ex);
      this.messageStatus.setStatus(Constants.statusMessage.error);
    } finally {
      this.isLoading.setFalse();
    }
  };

  loadPpurSettings = async () => {
    const res = await Api.getPpurSettings();
    return runInAction(() => {
      this.ppurSettings = res.data;
    });
  };

  savePPPUROrderSettings = async (data) => {
    this.isLoading.setTrue();
    try {
      await Api.updatePpurSettings(data);
      this.messageStatus.setStatus(Constants.statusMessage.updated);
    } catch (ex) {
      this.messageStatus.setDetails(ex);
      this.messageStatus.setStatus(Constants.statusMessage.error);
    } finally {
      this.isLoading.setFalse();
    }
  };

  loadASUEDSSettings = async () => {
    const res = await Api.getAsuEdsSettings();
    return runInAction(() => {
      this.asuEdsSettings = res.data;
    });
  };

  saveASUEDSOrderSettings = async (data) => {
    this.isLoading.setTrue();
    try {
      await Api.updateAsuEdsSettings(data);
      this.messageStatus.setStatus(Constants.statusMessage.updated);
    } catch (ex) {
      this.messageStatus.setDetails(ex);
      this.messageStatus.setStatus(Constants.statusMessage.error);
    } finally {
      this.isLoading.setFalse();
    }
  };

  saveBPEKOrderSettings = async (data) => {
    this.isLoading.setTrue();
    try {
      await Api.updateBpIekSettings(data);
      this.messageStatus.setStatus(Constants.statusMessage.updated);
    } catch (ex) {
      this.messageStatus.setDetails(ex);
      this.messageStatus.setStatus(Constants.statusMessage.error);
    } finally {
      this.isLoading.setFalse();
    }
  };

  loadGRPSettings = async () => {
    const res = await Api.getGRPSettings();
    return runInAction(() => {
      this.grpSettings = res.data;
    });
  };

  saveGrpSettings = async (data) => {
    this.isLoading.setTrue();
    try {
      await Api.updateGrpSettings(data);
      this.messageStatus.setStatus(Constants.statusMessage.updated);
    } catch (ex) {
      this.messageStatus.setDetails(ex);
      this.messageStatus.setStatus(Constants.statusMessage.error);
    } finally {
      this.isLoading.setFalse();
    }
  };

  uploadAipProjectExecutions = async () => {
    this.isLoading.setTrue();
    try {
      await Api.uploadAipProjectExecutions();
      this.messageStatus.setStatus(Constants.statusMessage.uploadSuccess);
    } catch (ex) {
      this.messageStatus.setDetails(ex);
      this.messageStatus.setStatus(Constants.statusMessage.error);
    } finally {
      this.isLoading.setFalse();
    }
  };

  saveGRPSettings = async (data) => {
    this.isLoading.setTrue();
    try {
      await Api.updateGrpSettings(data);
      this.messageStatus.setStatus(Constants.statusMessage.updated);
    } catch (ex) {
      this.messageStatus.setDetails(ex);
      this.messageStatus.setStatus(Constants.statusMessage.error);
    } finally {
      this.isLoading.setFalse();
    }
  };

  getSitPanelConfig = async () => {
    this.isLoading.setTrue();
    try {
      const res = await Api.getSitPanelConfig();

      runInAction(() => {
        this.sitPanelConfig = res.data;
      });
    } catch (e) {
      this.messageStatus.setDetails(e.response.data.errors);
      this.messageStatus.setStatus(Constants.statusMessage.error);
    } finally {
      this.isLoading.setFalse();
    }
  };

  updateSitPanelConfig = async (data) => {
    this.isLoading.setTrue();
    try {
      await Api.updateSitPanelConfig(data);
      this.messageStatus.setStatus(Constants.statusMessage.updated);
    } catch (e) {
      this.messageStatus.setDetails(e.response.data.errors);
      this.messageStatus.setStatus(Constants.statusMessage.error);
    } finally {
      this.isLoading.setFalse();
    }
  };
}

export const systemSettingsStore = new SystemSettingsStore();
